// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* our_student.css */

.our-student-page {
  --os-type-heading: clamp(2rem, 2.8vw, 2.6rem);
  --os-type-subheading: 1.2rem;
  --os-type-card-heading: 1.1rem;
  --os-type-body: 1rem;
  --os-type-label: 0.88rem;
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  background: #ece4ed;
  color: #0d121b;
  font-family: "Lexend", system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
}

.os-container {
  width: min(1100px, 100% - 48px);
  margin: 0 auto;
}

/* ---------- HERO ---------- */
.os-hero {
  position: relative;
  width: 100%;
  padding: 80px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.os-hero__overlay {
  position: absolute;
  inset: 0;
  background: #400C4D;
  opacity: 0.9;
  z-index: 1;
}

.os-hero__content {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.os-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
  margin-bottom: 18px;
}

.os-pill__icon {
  color: #f59e0b;
  font-size: 18px;
}

.os-pill__text {
  color: #ece4ed;
  font-size: var(--os-type-label);
  font-weight: 500;
  letter-spacing: 0.4px;
}

.os-hero__title {
  color: #ffffff;
  font-weight: 900;
  line-height: 1.05;
  letter-spacing: -0.03em;
  font-size: clamp(34px, 4vw, 60px);
  margin: 0 0 10px;
}

.os-hero__subtitle {
  color: rgba(219, 234, 254, 1);
  font-size: clamp(16px, 1.6vw, 20px);
  line-height: 1.5;
  max-width: 720px;
  margin: 0;
}

/* ---------- STATS ---------- */
.os-stats-wrap {
  position: relative;
  margin-top: -40px;
  padding-bottom: 12px;
}

.os-stats {
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 18px 40px rgba(13, 18, 27, 0.12);
  padding: 22px 18px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  overflow: hidden;
}

.os-stats--single {
  grid-template-columns: 1fr;
}

.os-stat {
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.os-stats--single .os-stat {
  max-width: 380px;
  margin: 0 auto;
}

.os-stat--mid {
  border-left: 1px solid #e5e7eb;
  border-right: 1px solid #e5e7eb;
}

.os-stat__iconWrap {
  width: 46px;
  height: 46px;
  border-radius: 9999px;
  display: grid;
  place-items: center;
  background: #F6EEF8;
  margin-bottom: 10px;
}

.os-stat__icon {
  color: #400C4D;
  font-size: 28px;
}

.os-stat__value {
  font-weight: 900;
  font-size: 36px;
  margin: 0;
}

.os-stat__label {
  color: #6b7280;
  font-size: var(--os-type-label);
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  margin-top: 4px;
}

/* ---------- SECTION HEADINGS ---------- */
.os-h2 {
  font-size: var(--os-type-heading);
  font-weight: 800;
  letter-spacing: -0.015em;
  margin: 0 0 6px;
}

.os-h2--big {
  font-size: clamp(28px, 2.6vw, 40px);
}

.os-muted {
  color: #6b7280;
  margin: 0;
}

.os-kicker {
  color: #400C4D;
  font-size: var(--os-type-label);
  font-weight: 900;
  letter-spacing: 0.14em;
}

/* ---------- PLACEHOLDER (for future images) ---------- */
.os-placeholder {
  background: #ece4ed;
  border: 1px dashed #400C4D;
  position: relative;
}

.os-placeholder__center {
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
  gap: 6px;
  color: #400C4D;
  font-weight: 800;
  opacity: 0.85;
}

.os-placeholder__center span.material-symbols-outlined {
  font-size: 28px;
}

/* ---------- TOP PERFORMERS ---------- */
.os-performers {
  padding: 58px 0 30px;
  background: #ece4ed;
}

.os-performers--muted {
  opacity: 0.42;
  filter: grayscale(0.15);
  pointer-events: none;
}

.os-performers__head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 26px;
}

.os-tabs {
  display: inline-flex;
  padding: 4px;
  background: #d6c3d9;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 1px 0 rgba(13, 18, 27, 0.04);
}

.os-tab {
  border: 0;
  background: transparent;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 650;
  color: #6b7280;
  cursor: pointer;
  transition: all 160ms ease;
}

.os-tab:hover {
  color: #400C4D;
}

.os-tab.is-active {
  background: #400C4D;
  color: #ffffff;
  box-shadow: 0 6px 14px rgba(64, 12, 77, 0.25);
}

.os-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;
}

.os-card {
  position: relative;
  border-radius: 14px;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #eef2f7;
  box-shadow: 0 2px 10px rgba(13, 18, 27, 0.05);
  transition: transform 200ms ease, box-shadow 200ms ease;
}

.os-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 18px 34px rgba(13, 18, 27, 0.12);
}

.os-card--gold {
  border: 1px solid #fcd34d;
  box-shadow: 0 4px 14px rgba(245, 158, 11, 0.15);
}

.os-card__badge {
  position: absolute;
  top: 0;
  right: 0;
  padding: 6px 10px;
  font-size: 0.85rem;
  font-weight: 800;
  color: #ffffff;
  border-bottom-left-radius: 10px;
  z-index: 2;
}

.os-card__badge.is-primary {
  background: #400C4D;
}

.os-card__badge.is-accent {
  background: #f59e0b;
}

.os-card__imgWrap {
  width: 100%;
  height: 220px;
  overflow: hidden;
}

.os-card__body {
  padding: 14px 14px 16px;
  text-align: center;
}

.os-card__name {
  margin: 0;
  font-size: 16px;
  font-weight: 800;
}

.os-card__meta {
  margin-top: 4px;
  color: #400C4D;
  font-weight: 700;
  font-size: var(--os-type-body);
}

.os-divider {
  width: 100%;
  height: 1px;
  background: #eef2f7;
  margin: 12px 0;
}

.os-card__tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: #f59e0b;
}

.os-star {
  font-size: 16px;
}

.os-card__tagText {
  font-size: 0.88rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  color: #6b7280;
  text-transform: uppercase;
}

.os-center {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.os-linkBtn {
  border: 0;
  background: transparent;
  color: #400C4D;
  font-weight: 800;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: gap 180ms ease;
}

.os-linkBtn:hover {
  gap: 12px;
}

.os-linkBtn__icon {
  font-size: 18px;
}

/* ---------- NEW: VIDEOS ROW SECTION ---------- */
.os-videoRow {
  padding: 34px 0 70px;
  background: #ece4ed;
}

.os-videoRow__head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 18px;
}

.os-videoRow__grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;
}

.os-videoTile {
  border-radius: 14px;
  overflow: hidden;
  background: #0b1220;
  box-shadow: 0 14px 26px rgba(13, 18, 27, 0.12);
  cursor: pointer;
  height: 280px;
  position: relative;
}

.os-videoTile__iframeWrap {
  width: 100%;
  height: 100%;
}

.os-ytFrame {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
}

.os-videoTile__caption {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 14px;
  color: #fff;
  font-weight: 700;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.78), rgba(0, 0, 0, 0));
}

/* ---------- Restored: Previously Mentored Students ---------- */
.os-mentored {
  background: #e0d8e2;
  padding: 70px 0 84px;
  border-top: 1px solid #eef2f7;
}

.os-mentored--muted {
  opacity: 1;
}

.os-mentored__title {
  text-align: center;
  margin-bottom: 28px;
}

.os-mentored__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
}

.os-mentoredCard {
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid #eef2f7;
  box-shadow: 0 2px 12px rgba(13, 18, 27, 0.06);
  overflow: hidden;
  transition: transform 180ms ease, box-shadow 180ms ease;
}

.os-mentoredCard:hover {
  transform: translateY(-3px);
  box-shadow: 0 18px 34px rgba(13, 18, 27, 0.12);
}

.os-mentoredCard__img {
  display: block;
  width: 100%;
  height: 210px;
  object-fit: contain;
  object-position: center;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  background: #f8fafc;
}

.os-mentoredCard__text {
  display: block;
  width: 100%;
  height: 140px;
  object-fit: contain;
  object-position: center;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  border-top: 1px solid rgba(64, 12, 77, 0.12);
  background: #f8fafc;
}

.os-mentoredCard__text--empty {
  transform: none;
}

.os-mentoredCard__meta {
  padding: 12px 14px 14px;
  text-align: center;
  background: #fff;
  position: relative;
  z-index: 1;
}

.os-mentoredCard__name {
  font-weight: 900;
  font-size: 22px;
  line-height: 1.25;
  color: #111827;
}

.os-mentoredCard__sub {
  margin-top: 4px;
  font-size: 0.95rem;
  color: #6b7280;
}

/* ---------- NEW: You Will Be the Next ---------- */
.os-next {
  background: #e0d8e2;
  padding: 70px 0 84px;
  border-top: 1px solid #eef2f7;
}

.os-next__title {
  text-align: center;
  margin-bottom: 28px;
}

.os-next .os-kicker {
  color: #5b1a65;
  letter-spacing: 0.14em;
}

.os-next .os-h2 {
  color: #2a0d33;
}

.os-next__line1 {
  color: #400C4D !important;
}

.os-next__word-next {
  color: red;
}

.os-next__tagline {
  margin: 10px 0 0;
  font-size: 22px;
  font-weight: 900;
  color: #400C4D;
}

.os-next__accent1 {
  color: red;
}

.os-next__accent2 {
  color: #400C4D;
}

.os-next__imageWrap {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.os-next__image {
  width: min(300px, 90vw);
  height: auto;
  display: block;
  border-radius: 14px;
  box-shadow: 0 14px 32px rgba(13, 18, 27, 0.14);
}

/* ---------- ALUMNI ---------- */
.os-alumni {
  background: #f8f9fc;
  border-top: 1px solid #e5e7eb;
  padding: 56px 0;
}

.os-alumni__inner {
  text-align: center;
}

.os-alumni__title {
  margin: 0 0 20px;
  color: #9ca3af;
  font-size: var(--os-type-label);
  font-weight: 900;
  letter-spacing: 0.16em;
}

.os-alumni__grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 12px;
  align-items: center;
  justify-content: center;
  opacity: 0.75;
  filter: grayscale(1);
  transition: filter 220ms ease, opacity 220ms ease;
}

.os-alumni__grid:hover {
  filter: grayscale(0);
  opacity: 1;
}

.os-alumni__pill {
  height: 46px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #eef2f7;
  display: grid;
  place-items: center;
  font-weight: 800;
  color: #6b7280;
  box-shadow: 0 1px 8px rgba(13, 18, 27, 0.05);
}

/* ---------- CTA ---------- */
.os-cta {
  position: relative;
  background: #400C4D;
  padding: 76px 0;
  overflow: hidden;
}

.os-cta__shape {
  position: absolute;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 9999px;
}

.os-cta__shape--tr {
  width: 260px;
  height: 260px;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
}

.os-cta__shape--bl {
  width: 380px;
  height: 380px;
  bottom: 0;
  left: 0;
  transform: translate(-50%, 50%);
}

.os-cta__inner {
  position: relative;
  z-index: 1;
  text-align: center;
  width: min(800px, 100% - 48px);
}

.os-cta__title {
  color: #fff;
  font-weight: 900;
  letter-spacing: -0.02em;
  font-size: clamp(28px, 4vw, 52px);
  margin: 0 0 14px;
}

.os-cta__sub {
  color: rgba(219, 234, 254, 1);
  font-size: 18px;
  line-height: 1.6;
  margin: 0 auto 22px;
  max-width: 660px;
}

.os-cta__btns {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

.os-btn {
  border: 0;
  padding: 14px 22px;
  border-radius: 10px;
  font-weight: 900;
  cursor: pointer;
  transition: transform 160ms ease, box-shadow 160ms ease, background 160ms ease;
}

.os-btn--white {
  background: #ffffff;
  color: #400C4D;
  box-shadow: 0 14px 24px rgba(13, 18, 27, 0.18);
}

.os-btn--white:hover {
  background: #f3f4f6;
  color: #f59e0b;
  transform: translateY(-2px);
}

.os-btn--outline {
  background: transparent;
  border: 2px solid #ffffff;
  color: #ffffff;
}

.os-btn--outline:hover {
  color: #f59e0b;
}

/* ---------- Responsive ---------- */
@media (max-width: 1024px) {
  .os-cards {
    grid-template-columns: repeat(2, 1fr);
  }

  .os-videoRow__grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .os-videoTile {
    height: 260px;
  }

  .os-mentored__grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .os-next__image {
    width: min(420px, 88vw);
  }

  .os-alumni__grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 820px) {
  .os-performers__head {
    flex-direction: column;
    align-items: flex-start;
  }

  .os-stat--mid {
    border-left: 0;
    border-right: 0;
  }

  .os-stats {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .os-stat {
    border-top: 1px solid #e5e7eb;
  }

  .os-stat:first-child {
    border-top: 0;
  }
}

@media (max-width: 520px) {
  .os-container {
    width: min(1100px, 100% - 28px);
  }

  .os-cards {
    grid-template-columns: 1fr;
  }

  .os-videoRow__grid {
    grid-template-columns: 1fr;
  }

  .os-videoTile {
    height: 240px;
  }

  .os-mentored__grid {
    grid-template-columns: 1fr;
  }

  .os-next__tagline {
    font-size: 16px;
  }

  .os-next__image {
    width: min(340px, 88vw);
  }

  .os-alumni__grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* ===== Featured centered video (16:9) ===== */
.os-featuredVideo {
  padding: 32px 0 8px;
}

.os-featuredVideo__frameWrap {
  max-width: 800px;
  margin: 0 auto;
  aspect-ratio: 16 / 9;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 12px 32px rgba(30, 42, 74, 0.18);
  background: #000;
}

.os-featuredVideo__frame {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
}

@media (max-width: 640px) {
  .os-featuredVideo {
    padding: 20px 0 4px;
  }
  .os-featuredVideo__frameWrap {
    border-radius: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/testimonials/our_student.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;EACE,6CAA6C;EAC7C,4BAA4B;EAC5B,8BAA8B;EAC9B,oBAAoB;EACpB,wBAAwB;EACxB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,oFAAoF;AACtF;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qBAAqB;EACrB,oCAAoC;EACpC,0CAA0C;EAC1C,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB;;AAEA,2CAA2C;AAC3C;EACE,iCAAiC;EACjC,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,0DAA0D;AAC1D;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA,yCAAyC;AACzC;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;EAC7C,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA,kDAAkD;AAClD;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;EAC9C,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,0EAA0E;AAC5E;;AAEA,iEAAiE;AACjE;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;EAC7C,gBAAgB;EAChB,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,4BAA4B;EAC5B,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,4CAA4C;AAC9C;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,MAAM;EACN,QAAQ;EACR,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,SAAS;EACT,OAAO;EACP,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA,+CAA+C;AAC/C;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,cAAc;AAChB;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* our_student.css */\n\n.our-student-page {\n  --os-type-heading: clamp(2rem, 2.8vw, 2.6rem);\n  --os-type-subheading: 1.2rem;\n  --os-type-card-heading: 1.1rem;\n  --os-type-body: 1rem;\n  --os-type-label: 0.88rem;\n  width: 100%;\n  min-height: 100vh;\n  overflow-x: hidden;\n  background: #ece4ed;\n  color: #0d121b;\n  font-family: \"Lexend\", system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;\n}\n\n.os-container {\n  width: min(1100px, 100% - 48px);\n  margin: 0 auto;\n}\n\n/* ---------- HERO ---------- */\n.os-hero {\n  position: relative;\n  width: 100%;\n  padding: 80px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.os-hero__overlay {\n  position: absolute;\n  inset: 0;\n  background: #400C4D;\n  opacity: 0.9;\n  z-index: 1;\n}\n\n.os-hero__content {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.os-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px;\n  border-radius: 9999px;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(8px);\n  margin-bottom: 18px;\n}\n\n.os-pill__icon {\n  color: #f59e0b;\n  font-size: 18px;\n}\n\n.os-pill__text {\n  color: #ece4ed;\n  font-size: var(--os-type-label);\n  font-weight: 500;\n  letter-spacing: 0.4px;\n}\n\n.os-hero__title {\n  color: #ffffff;\n  font-weight: 900;\n  line-height: 1.05;\n  letter-spacing: -0.03em;\n  font-size: clamp(34px, 4vw, 60px);\n  margin: 0 0 10px;\n}\n\n.os-hero__subtitle {\n  color: rgba(219, 234, 254, 1);\n  font-size: clamp(16px, 1.6vw, 20px);\n  line-height: 1.5;\n  max-width: 720px;\n  margin: 0;\n}\n\n/* ---------- STATS ---------- */\n.os-stats-wrap {\n  position: relative;\n  margin-top: -40px;\n  padding-bottom: 12px;\n}\n\n.os-stats {\n  background: #ffffff;\n  border-radius: 14px;\n  box-shadow: 0 18px 40px rgba(13, 18, 27, 0.12);\n  padding: 22px 18px;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  overflow: hidden;\n}\n\n.os-stats--single {\n  grid-template-columns: 1fr;\n}\n\n.os-stat {\n  padding: 10px 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.os-stats--single .os-stat {\n  max-width: 380px;\n  margin: 0 auto;\n}\n\n.os-stat--mid {\n  border-left: 1px solid #e5e7eb;\n  border-right: 1px solid #e5e7eb;\n}\n\n.os-stat__iconWrap {\n  width: 46px;\n  height: 46px;\n  border-radius: 9999px;\n  display: grid;\n  place-items: center;\n  background: #F6EEF8;\n  margin-bottom: 10px;\n}\n\n.os-stat__icon {\n  color: #400C4D;\n  font-size: 28px;\n}\n\n.os-stat__value {\n  font-weight: 900;\n  font-size: 36px;\n  margin: 0;\n}\n\n.os-stat__label {\n  color: #6b7280;\n  font-size: var(--os-type-label);\n  font-weight: 600;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  margin-top: 4px;\n}\n\n/* ---------- SECTION HEADINGS ---------- */\n.os-h2 {\n  font-size: var(--os-type-heading);\n  font-weight: 800;\n  letter-spacing: -0.015em;\n  margin: 0 0 6px;\n}\n\n.os-h2--big {\n  font-size: clamp(28px, 2.6vw, 40px);\n}\n\n.os-muted {\n  color: #6b7280;\n  margin: 0;\n}\n\n.os-kicker {\n  color: #400C4D;\n  font-size: var(--os-type-label);\n  font-weight: 900;\n  letter-spacing: 0.14em;\n}\n\n/* ---------- PLACEHOLDER (for future images) ---------- */\n.os-placeholder {\n  background: #ece4ed;\n  border: 1px dashed #400C4D;\n  position: relative;\n}\n\n.os-placeholder__center {\n  width: 100%;\n  height: 100%;\n  display: grid;\n  place-items: center;\n  gap: 6px;\n  color: #400C4D;\n  font-weight: 800;\n  opacity: 0.85;\n}\n\n.os-placeholder__center span.material-symbols-outlined {\n  font-size: 28px;\n}\n\n/* ---------- TOP PERFORMERS ---------- */\n.os-performers {\n  padding: 58px 0 30px;\n  background: #ece4ed;\n}\n\n.os-performers--muted {\n  opacity: 0.42;\n  filter: grayscale(0.15);\n  pointer-events: none;\n}\n\n.os-performers__head {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 18px;\n  margin-bottom: 26px;\n}\n\n.os-tabs {\n  display: inline-flex;\n  padding: 4px;\n  background: #d6c3d9;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  box-shadow: 0 1px 0 rgba(13, 18, 27, 0.04);\n}\n\n.os-tab {\n  border: 0;\n  background: transparent;\n  padding: 8px 12px;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  font-weight: 650;\n  color: #6b7280;\n  cursor: pointer;\n  transition: all 160ms ease;\n}\n\n.os-tab:hover {\n  color: #400C4D;\n}\n\n.os-tab.is-active {\n  background: #400C4D;\n  color: #ffffff;\n  box-shadow: 0 6px 14px rgba(64, 12, 77, 0.25);\n}\n\n.os-cards {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 18px;\n}\n\n.os-card {\n  position: relative;\n  border-radius: 14px;\n  overflow: hidden;\n  background: #ffffff;\n  border: 1px solid #eef2f7;\n  box-shadow: 0 2px 10px rgba(13, 18, 27, 0.05);\n  transition: transform 200ms ease, box-shadow 200ms ease;\n}\n\n.os-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 18px 34px rgba(13, 18, 27, 0.12);\n}\n\n.os-card--gold {\n  border: 1px solid #fcd34d;\n  box-shadow: 0 4px 14px rgba(245, 158, 11, 0.15);\n}\n\n.os-card__badge {\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 6px 10px;\n  font-size: 0.85rem;\n  font-weight: 800;\n  color: #ffffff;\n  border-bottom-left-radius: 10px;\n  z-index: 2;\n}\n\n.os-card__badge.is-primary {\n  background: #400C4D;\n}\n\n.os-card__badge.is-accent {\n  background: #f59e0b;\n}\n\n.os-card__imgWrap {\n  width: 100%;\n  height: 220px;\n  overflow: hidden;\n}\n\n.os-card__body {\n  padding: 14px 14px 16px;\n  text-align: center;\n}\n\n.os-card__name {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 800;\n}\n\n.os-card__meta {\n  margin-top: 4px;\n  color: #400C4D;\n  font-weight: 700;\n  font-size: var(--os-type-body);\n}\n\n.os-divider {\n  width: 100%;\n  height: 1px;\n  background: #eef2f7;\n  margin: 12px 0;\n}\n\n.os-card__tag {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  color: #f59e0b;\n}\n\n.os-star {\n  font-size: 16px;\n}\n\n.os-card__tagText {\n  font-size: 0.88rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  color: #6b7280;\n  text-transform: uppercase;\n}\n\n.os-center {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.os-linkBtn {\n  border: 0;\n  background: transparent;\n  color: #400C4D;\n  font-weight: 800;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  transition: gap 180ms ease;\n}\n\n.os-linkBtn:hover {\n  gap: 12px;\n}\n\n.os-linkBtn__icon {\n  font-size: 18px;\n}\n\n/* ---------- NEW: VIDEOS ROW SECTION ---------- */\n.os-videoRow {\n  padding: 34px 0 70px;\n  background: #ece4ed;\n}\n\n.os-videoRow__head {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  margin-bottom: 18px;\n}\n\n.os-videoRow__grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 18px;\n}\n\n.os-videoTile {\n  border-radius: 14px;\n  overflow: hidden;\n  background: #0b1220;\n  box-shadow: 0 14px 26px rgba(13, 18, 27, 0.12);\n  cursor: pointer;\n  height: 280px;\n  position: relative;\n}\n\n.os-videoTile__iframeWrap {\n  width: 100%;\n  height: 100%;\n}\n\n.os-ytFrame {\n  width: 100%;\n  height: 100%;\n  border: 0;\n  display: block;\n}\n\n.os-videoTile__caption {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  padding: 14px;\n  color: #fff;\n  font-weight: 700;\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.78), rgba(0, 0, 0, 0));\n}\n\n/* ---------- Restored: Previously Mentored Students ---------- */\n.os-mentored {\n  background: #e0d8e2;\n  padding: 70px 0 84px;\n  border-top: 1px solid #eef2f7;\n}\n\n.os-mentored--muted {\n  opacity: 1;\n}\n\n.os-mentored__title {\n  text-align: center;\n  margin-bottom: 28px;\n}\n\n.os-mentored__grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 18px;\n}\n\n.os-mentoredCard {\n  background: #ffffff;\n  border-radius: 14px;\n  border: 1px solid #eef2f7;\n  box-shadow: 0 2px 12px rgba(13, 18, 27, 0.06);\n  overflow: hidden;\n  transition: transform 180ms ease, box-shadow 180ms ease;\n}\n\n.os-mentoredCard:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 18px 34px rgba(13, 18, 27, 0.12);\n}\n\n.os-mentoredCard__img {\n  display: block;\n  width: 100%;\n  height: 210px;\n  object-fit: contain;\n  object-position: center;\n  image-rendering: -webkit-optimize-contrast;\n  image-rendering: crisp-edges;\n  background: #f8fafc;\n}\n\n.os-mentoredCard__text {\n  display: block;\n  width: 100%;\n  height: 140px;\n  object-fit: contain;\n  object-position: center;\n  image-rendering: -webkit-optimize-contrast;\n  image-rendering: crisp-edges;\n  border-top: 1px solid rgba(64, 12, 77, 0.12);\n  background: #f8fafc;\n}\n\n.os-mentoredCard__text--empty {\n  transform: none;\n}\n\n.os-mentoredCard__meta {\n  padding: 12px 14px 14px;\n  text-align: center;\n  background: #fff;\n  position: relative;\n  z-index: 1;\n}\n\n.os-mentoredCard__name {\n  font-weight: 900;\n  font-size: 22px;\n  line-height: 1.25;\n  color: #111827;\n}\n\n.os-mentoredCard__sub {\n  margin-top: 4px;\n  font-size: 0.95rem;\n  color: #6b7280;\n}\n\n/* ---------- NEW: You Will Be the Next ---------- */\n.os-next {\n  background: #e0d8e2;\n  padding: 70px 0 84px;\n  border-top: 1px solid #eef2f7;\n}\n\n.os-next__title {\n  text-align: center;\n  margin-bottom: 28px;\n}\n\n.os-next .os-kicker {\n  color: #5b1a65;\n  letter-spacing: 0.14em;\n}\n\n.os-next .os-h2 {\n  color: #2a0d33;\n}\n\n.os-next__line1 {\n  color: #400C4D !important;\n}\n\n.os-next__word-next {\n  color: red;\n}\n\n.os-next__tagline {\n  margin: 10px 0 0;\n  font-size: 22px;\n  font-weight: 900;\n  color: #400C4D;\n}\n\n.os-next__accent1 {\n  color: red;\n}\n\n.os-next__accent2 {\n  color: #400C4D;\n}\n\n.os-next__imageWrap {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.os-next__image {\n  width: min(300px, 90vw);\n  height: auto;\n  display: block;\n  border-radius: 14px;\n  box-shadow: 0 14px 32px rgba(13, 18, 27, 0.14);\n}\n\n/* ---------- ALUMNI ---------- */\n.os-alumni {\n  background: #f8f9fc;\n  border-top: 1px solid #e5e7eb;\n  padding: 56px 0;\n}\n\n.os-alumni__inner {\n  text-align: center;\n}\n\n.os-alumni__title {\n  margin: 0 0 20px;\n  color: #9ca3af;\n  font-size: var(--os-type-label);\n  font-weight: 900;\n  letter-spacing: 0.16em;\n}\n\n.os-alumni__grid {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 12px;\n  align-items: center;\n  justify-content: center;\n  opacity: 0.75;\n  filter: grayscale(1);\n  transition: filter 220ms ease, opacity 220ms ease;\n}\n\n.os-alumni__grid:hover {\n  filter: grayscale(0);\n  opacity: 1;\n}\n\n.os-alumni__pill {\n  height: 46px;\n  border-radius: 10px;\n  background: #fff;\n  border: 1px solid #eef2f7;\n  display: grid;\n  place-items: center;\n  font-weight: 800;\n  color: #6b7280;\n  box-shadow: 0 1px 8px rgba(13, 18, 27, 0.05);\n}\n\n/* ---------- CTA ---------- */\n.os-cta {\n  position: relative;\n  background: #400C4D;\n  padding: 76px 0;\n  overflow: hidden;\n}\n\n.os-cta__shape {\n  position: absolute;\n  background: rgba(255, 255, 255, 0.06);\n  border-radius: 9999px;\n}\n\n.os-cta__shape--tr {\n  width: 260px;\n  height: 260px;\n  top: 0;\n  right: 0;\n  transform: translate(50%, -50%);\n}\n\n.os-cta__shape--bl {\n  width: 380px;\n  height: 380px;\n  bottom: 0;\n  left: 0;\n  transform: translate(-50%, 50%);\n}\n\n.os-cta__inner {\n  position: relative;\n  z-index: 1;\n  text-align: center;\n  width: min(800px, 100% - 48px);\n}\n\n.os-cta__title {\n  color: #fff;\n  font-weight: 900;\n  letter-spacing: -0.02em;\n  font-size: clamp(28px, 4vw, 52px);\n  margin: 0 0 14px;\n}\n\n.os-cta__sub {\n  color: rgba(219, 234, 254, 1);\n  font-size: 18px;\n  line-height: 1.6;\n  margin: 0 auto 22px;\n  max-width: 660px;\n}\n\n.os-cta__btns {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.os-btn {\n  border: 0;\n  padding: 14px 22px;\n  border-radius: 10px;\n  font-weight: 900;\n  cursor: pointer;\n  transition: transform 160ms ease, box-shadow 160ms ease, background 160ms ease;\n}\n\n.os-btn--white {\n  background: #ffffff;\n  color: #400C4D;\n  box-shadow: 0 14px 24px rgba(13, 18, 27, 0.18);\n}\n\n.os-btn--white:hover {\n  background: #f3f4f6;\n  color: #f59e0b;\n  transform: translateY(-2px);\n}\n\n.os-btn--outline {\n  background: transparent;\n  border: 2px solid #ffffff;\n  color: #ffffff;\n}\n\n.os-btn--outline:hover {\n  color: #f59e0b;\n}\n\n/* ---------- Responsive ---------- */\n@media (max-width: 1024px) {\n  .os-cards {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .os-videoRow__grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .os-videoTile {\n    height: 260px;\n  }\n\n  .os-mentored__grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .os-next__image {\n    width: min(420px, 88vw);\n  }\n\n  .os-alumni__grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 820px) {\n  .os-performers__head {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .os-stat--mid {\n    border-left: 0;\n    border-right: 0;\n  }\n\n  .os-stats {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n\n  .os-stat {\n    border-top: 1px solid #e5e7eb;\n  }\n\n  .os-stat:first-child {\n    border-top: 0;\n  }\n}\n\n@media (max-width: 520px) {\n  .os-container {\n    width: min(1100px, 100% - 28px);\n  }\n\n  .os-cards {\n    grid-template-columns: 1fr;\n  }\n\n  .os-videoRow__grid {\n    grid-template-columns: 1fr;\n  }\n\n  .os-videoTile {\n    height: 240px;\n  }\n\n  .os-mentored__grid {\n    grid-template-columns: 1fr;\n  }\n\n  .os-next__tagline {\n    font-size: 16px;\n  }\n\n  .os-next__image {\n    width: min(340px, 88vw);\n  }\n\n  .os-alumni__grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n/* ===== Featured centered video (16:9) ===== */\n.os-featuredVideo {\n  padding: 32px 0 8px;\n}\n\n.os-featuredVideo__frameWrap {\n  max-width: 800px;\n  margin: 0 auto;\n  aspect-ratio: 16 / 9;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 12px 32px rgba(30, 42, 74, 0.18);\n  background: #000;\n}\n\n.os-featuredVideo__frame {\n  width: 100%;\n  height: 100%;\n  border: 0;\n  display: block;\n}\n\n@media (max-width: 640px) {\n  .os-featuredVideo {\n    padding: 20px 0 4px;\n  }\n  .os-featuredVideo__frameWrap {\n    border-radius: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
